import React from 'react';
import './styles/animations.css';

// Components
import Navigation from './components/Navigation';
import Hero from './components/Hero';
import PivotTimeline from './components/PivotTimeline';
import ProjectShowcase from './components/ProjectShowcase';
import NCARVault from './components/NCARVault';
import WeatherWiseLog from './components/WeatherWiseLog';
import TechArsenal from './components/TechArsenal';
import PromptAndParadox from './components/PromptAndParadox';
import WorkWithMe from './components/WorkWithMe';
import Footer from './components/Footer';

function App() {
  return (
    <div className="relative min-h-screen bg-background text-text-primary">
      {/* Navigation */}
      <Navigation />

      {/* Main Content */}
      <main className="relative">
        {/* Hero Section */}
        <Hero />

        {/* The Pivot Timeline */}
        <PivotTimeline />

        {/* Project Showcase */}
        <ProjectShowcase />

        {/* NCAR Legacy Vault */}
        <NCARVault />

        {/* WeatherWise.ai Build Log */}
        <WeatherWiseLog />

        {/* Technical Arsenal */}
        <TechArsenal />

        {/* PromptAndParadox */}
        <PromptAndParadox />

        {/* Work With Me / Contact */}
        <WorkWithMe />
      </main>

      {/* Footer */}
      <Footer />
    </div>
  );
}

export default App;
